import { ProductCopyApp } from "./ui/ProductCopyApp";

export function Root() {
  return <ProductCopyApp />;
}
